import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { DeleteRegisterRequestParams } from './request';
import { deleteRegisterRequest } from './request';

export const useDeleteRegisterRequestMutation = (
  settings?: MutationSettings<
    DeleteRegisterRequestParams,
    typeof deleteRegisterRequest
  >
) =>
  useMutation({
    mutationKey: ['deleteRegisterRequest'],
    mutationFn: ({ config, params }) =>
      deleteRegisterRequest({
        params,
        config
      }),
    ...settings?.options
  });
